import {
  LayoutDashboard, Users, Calendar, CalendarOff, Building2, User,
} from 'lucide-react';

/**
 * The navigation, as data. The desktop sidebar, the phone drawer and the
 * bottom bar all render from this one list, so they cannot drift apart.
 *
 * `labelKey` is an app_lang key; `labelFallback` is what LanguageContext
 * renders when that key is missing from the database. Both are needed: this
 * app used to call print_lang(key, key), so an unseeded database put the raw
 * strings "my_calendar", "day_off" and "profile" on screen. The rows are
 * seeded by databases/dentists_app_mobile_shell.sql, but the database should
 * improve the UI, not be a prerequisite for it — which is how
 * admin-app/src/navItems.js already does it.
 */
export const NAV_ITEMS = [
  { id: 'dashboard',    labelKey: 'dashboard',        labelFallback: 'Dashboard',        Icon: LayoutDashboard },
  { id: 'waiting-list', labelKey: 'waiting_list',     labelFallback: 'Waiting List',     Icon: Users },
  { id: 'calendar',     labelKey: 'my_calendar',      labelFallback: 'My Calendar',      Icon: Calendar },
  { id: 'dayoff',       labelKey: 'day_off',          labelFallback: 'Day Off',          Icon: CalendarOff },
  { id: 'branches',     labelKey: 'working_branches', labelFallback: 'Working Branches', Icon: Building2 },
  { id: 'profile',      labelKey: 'profile',          labelFallback: 'Profile',          Icon: User },
];

/**
 * The four bottom-bar slots before "More" (spec §4.1). Working Branches and
 * Profile live in the More sheet.
 */
export const BOTTOM_NAV_IDS = ['dashboard', 'waiting-list', 'calendar', 'dayoff'];
